/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedTaskInputObjectivesAnyOf } from './exportedTaskInputObjectivesAnyOf';

export type ExportedTaskInputObjectives = ExportedTaskInputObjectivesAnyOf | null;
